export default "__VITE_ASSET__BRRmPcBW__"